export const SET_USER = 'USER/SET_USER';
export const SET_IS_NEW_EMAIL_NOTIFICATION = 'USER/SET_IS_NEW_EMAIL_NOTIFICATION';
export const SET_MAINTENANCE_BYPASS_TOKEN = 'USER/SET_MAINTENANCE_BYPASS_TOKEN';

export const setUser = user => ({
  type: SET_USER,
  user,
});
export const setIsNewEmailNotification = isNewEmailNotification => ({
  type: SET_IS_NEW_EMAIL_NOTIFICATION,
  isNewEmailNotification,
});
export const setMaintenanceBypassToken = maintenanceBypassToken => ({
  type: SET_MAINTENANCE_BYPASS_TOKEN,
  maintenanceBypassToken,
});

const getDefaultState = () => {
  return {
    user: null,
    isNewEmailNotification: true,
    maintenanceBypassToken: null,
  };
};

export default function reducer(
  state = {
    ...getDefaultState(),
  },
  action
) {
  switch (action.type) {
    case SET_USER:
      return { ...state, user: action.user };
    case SET_IS_NEW_EMAIL_NOTIFICATION:
      return { ...state, isNewEmailNotification: action.isNewEmailNotification };
    case SET_MAINTENANCE_BYPASS_TOKEN:
      return { ...state, maintenanceBypassToken: action.maintenanceBypassToken };
    default:
      break;
  }
  return state;
}
